<template>
    <div class="tabla-contenedor">
        <table class="tabla-principal" id="productTable">
            <thead>
                <tr>
                    <th v-for="col in columns" :key="col.key" :class="[col.key, col.class]" v-if="">{{ col.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, rowIndex) in filterItems" :key="item.id"
                    :class="{ selectedRow: selected.row === rowIndex }">
                    <td v-for="(col, colIndex) in columns" :key="col.key" :class="[col.key, {
                        selectedCell:
                            selected.row === rowIndex &&
                            selected.col === colIndex &&
                            col.editable
                    }, col.class]"
                    @click="col.editable && selectCell(rowIndex, colIndex)">
                        <div v-if="col.key == 'id' " :class="[col.key, col.class]">{{ rowIndex + 1 }}</div>
                        <div v-else-if="col.key == 'name_account' " :class="[col.key, col.class]">
                            <model-select class="name_account" :ref="'accountInput-'+rowIndex" :options="TypeofAccount" :id="col.key+'-'+rowIndex"
                                v-model="item.account_id" required="true" @blur="setUpdate(item)">
                            </model-select>
                        </div>
                        <div v-else-if="col.key == 'productname' " :class="[col.key, col.class]">
                            <input type="text" v-model="item[col.key]" @change="setUpdate(item)" :id="col.key+'-'+rowIndex">
                        </div>
                        <div v-else-if="col.key == 'description'" :class="[col.key, col.class]" >
                            <textarea :id="col.key+'-'+rowIndex" v-model="item[col.key]" @change="setUpdate(item)" placeholder="Description"></textarea>
                        </div>
                        <div v-else-if="col.key == 'unitcost'" :class="[col.key, col.class]">
                            <AmountInput class_input="cost" v-model="item.unitcost" :subtotal="99999999"
                                    modo_calc="amount" @save="setUpdate(item)" />
                        </div>
                        <div v-else-if="col.key == 'cogs' " :class="[col.key, col.class]">
                            <AmountInput class_input="cogs" v-model="item.cogs" :subtotal="99999999"
                                    modo_calc="amount" @save="setUpdate(item)" /><button><i class="fas fa-cog"></i></button>
                        </div>
                        <div v-else-if="col.key == 'quantity' " :class="[col.key, col.class]">
                            <QtyInput class_input="qty" v-model="item.quantity" @save="setUpdate(item)" />
                        </div>
                        <div v-else-if="col.key== 'applytax'">
                            <model-select class="applytax" :ref="'applytaxInput-'+rowIndex" :options="TaxesLists" :id="col.key+'-'+rowIndex"
                            v-model="item.applytax" required="true" @blur="setUpdate(item)" placeholder="Tax %">
                            </model-select>
                        </div>
                        <div v-else-if="col.key == 'status'" :class="[col.key, col.class]">
                            <!-- <span class="badge badge-success" v-if="item[col.key] == 1" >Active</span>
                            <span class="badge badge-secondary" v-else >Inactive</span> -->
                            <div class="onoffswitch statusProdServ">
                                <input type="checkbox" class="onoffswitch-checkbox" :id="'status' + rowIndex"
                                    :checked="item[col.key] == 1" @change="statusChange($event, item)" />
                                <label class="onoffswitch-label" :for="'status' + rowIndex">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </div>
                        <div v-else-if="col.key == 'actions'" :class="[col.key, col.class]">
                            <DropdownMenu :buttonClass="['base', 'btn-actions']">
                                <template v-slot:button>
                                    <i class="fas fa-ellipsis-v"></i>
                                </template>
                                <template v-slot:menu>
                                    <ul style="margin: 0; padding: 0; list-style: none" class="list-actions">
                                        <li>
                                            <button @click="$emit('onEditProduct', item)" class="text-left textAction">
                                                <i class="fas fa-edit"></i>
                                                Edit
                                            </button>
                                        </li>
                                        <li>
                                            <button @click="$emit('onDeleteProduct', item.id)" class="text-left textAction">
                                                <i class="fas fa-times"></i>
                                                Delete
                                            </button>
                                        </li>
                                    </ul>
                                </template>
                            </DropdownMenu>
                        </div>
                        <div v-else :class="[col.key, col.class]">{{ item[col.key] }}</div>
                    </td>
                </tr>
            </tbody>
		</table>
        <modal name="modal-detail" height="auto">
            <div class="card-body" style="white-space: break-spaces;">{{ description_product }}</div>
        </modal>
    </div>
</template>
<script>
import DropdownMenu from '@/core/components/DropdownMenu.vue'
import { ModelSelect } from 'vue-search-select';
import QtyInput from '@/apps/billing/components/calcManual/inputs/QtyInput.vue';
import AmountInput from '@/apps/billing/components/calcManual/inputs/AmountInput.vue';
export default {
    components: {
        DropdownMenu,
        ModelSelect,
        QtyInput,
        AmountInput,
    },
    props: {
        prodServiceLists: {
            type: Array,
            required: true
        },
        filterProduct: {
            type: [String, null],
            required: true
        },
    },
    data() {
        return {
            isLoading: false,
            columns: [
                { key: "id", label: "#", class: '', editable: false },
                { key: "name_account", label: "Account", class: '', editable: false },
                { key: "productname", label: "Name", class: '', editable: false },
                { key: "description", label: "Description", class: '', editable: false },
                { key: "unitcost", label: "Unit Cost", class: '', editable: false },
                { key: "cogs", label: "cogs", class: '', editable: false },
                { key: "quantity", label: "Qty", class: '', editable: false },
                { key: "applytax", label: "Taxes", class: 'taxes', editable: false },
                { key: "status", label: "Status", class: '', editable: false },
				{ key: "actions", label: "...", class: 'actions text-center', editable: false },
            ],
			selected: {
				row: null,
				col: null,
				editing: false
			},
            TaxesLists: [],
            TypeofAccount: [],
            description_product: null,
        };
    },
    created(){
        this.getTaxes();
        this.getAccountTypes();
    },
    mounted() {
    },
    methods: {
		selectCell(rowIndex, colIndex) {
			this.selected.row = rowIndex;
			this.selected.col = colIndex;
			this.selected.editing = true;

			this.$nextTick(() => {
				const input = this.$refs.editableInput;
				if (input && input[0]) {
					input[0].focus();
					input[0].select();
				}
			});
		},
        getTaxes() {
            this.TaxesLists = [];
            window.billing
            .get("taxes/" + window.localuserdata)
            .then((response) => {
                // console.log(response.data);
                if(response.data){
                    this.TaxesLists.push({value: 0, text: 'Tax %'});
                    if(response.data.length > 0){
                        response.data.filter((item) => {
                            this.TaxesLists.push({value: item.id, text: item.initialstate+' '+item.name+'%'});
                        });
                    }
                }
                // console.log('TaxesLists', this.TaxesLists)
            })
            .catch((error) => console.log(error));
        },
        getAccountTypes() {
            this.isLoading = true;
            window.billing
                .get("chart-account-list/" + window.localuserdata)
                .then((response) => {
                    // console.log("Account type form modal es
                    this.TypeofAccount = response.data.result;
                    let e = response.data.result;
                    if (e.length > 0) {
                        for (let i in e) {
                            this.TypeofAccount[i].value = this.TypeofAccount[i].id;
                            this.TypeofAccount[i].text = this.TypeofAccount[
                                i
                            ].name_account;
                        }
                    }
                    // console.log(this.TypeofAccount);
                    this.isLoading = false;
                })
                .catch((error) => console.log(error));
        },
        showDetails(desc) {
            if(desc!=null || desc!=''){
                this.$modal.show("modal-detail");
                this.description_product = desc;
            }
        },
        statusChange(event, item){
            let t= this;
            this.$nextTick(() => {
                item.status = event.target.checked ? 1 : 0
                t.setUpdate(item);
            });
        },
        setUpdate(item){
            console.log('setUpdate', item)
            window.billing
            .put("product-services/edit/" + item.id, {
                user_id: window.localuserdata,
                account_id: item.account_id,
                productname: item.productname,
                quantity: item.quantity,
                unitcost: item.unitcost,
                cogs: item.cogs,
                description: item.description,
                applytax: item.applytax,
                status: item.status,
            })
            .then((response) => {
                console.log("product-services/edit/", response.data);
            })
            .catch((error) => {
                console.log(error)
            });
        },
    },
    computed: {
        filterItems: function () {
            let t= this;
            if(t.filterProduct === null || t.filterProduct === ''){
                return this.prodServiceLists;
            }
            return this.prodServiceLists.filter(function (item) {
                return (
                    (item.name_account &&
                        item.name_account
                            .toLowerCase()
                            .indexOf(t.filterProduct.toLowerCase()) >= 0) ||
                    (item.productname &&
                        item.productname
                            .toLowerCase()
                            .indexOf(t.filterProduct.toLowerCase()) >= 0)||
                    (item.description &&
                        item.description
                            .toLowerCase()
                            .indexOf(t.filterProduct.toLowerCase()) >= 0)
                );
            });
        },
    }
};
</script>
<style scoped>
@import url('../tableProduct.scss');
td {
    font-size: 12px;
    line-height: 1.1;
}
th.id, td.id {
    width: 25px;
    min-width: 25px;
    max-width: 25px;
    text-align: center;
}
th.name_account, td.name_account {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
}
th.productname, td.productname {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
}
th.description, td.description {
    min-width: 250px;
}
td.description div.description {
    white-space: break-spaces;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* máximo 3 líneas */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
th.unitcost, td.unitcost {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    text-align: right;
}
th.cogs, td.cogs {
    width: 120px;
    min-width: 120px;
    max-width: 120px;
    text-transform: uppercase;
    text-align: right;
}
th.quantity, td.quantity {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    text-align: center;
}
th.applytax, td.applytax {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
}
th.status, td.status {
    width: 57px;
    min-width: 57px;
    max-width: 57px;
}
th.actions, td.actions {
    width: 57px;
    min-width: 57px;
    max-width: 57px;
}
ul.list-actions li {
    padding: 0px!important;
}
ul.list-actions li button {
    display: block;
    width: 100%;
    padding: 5px 10px;
}
ul.list-actions li button:focus, ul.list-actions li button:hover {outline: none;}

</style>

